module.exports = __webpack_public_path__ + "img/p38.3d372a0d.png";